module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blain-logistics"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_c('span', {
    staticClass: "logo"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Shipments in Transit")])])]), _vm._v(" "), _c('div', {
    staticClass: "main-wrapper"
  }, [_c('div', {
    staticClass: "top-wrapper"
  }, [_c('div', {
    staticClass: "us-map",
    attrs: {
      "id": "usmap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkout-sessions"
  }, [_c('h2', [_vm._v("[TODO]")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d52f163e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/blain-logistics.vue
// module id = 580
// module chunks = 0